import React, { Component } from "react";
import { StartPage } from "./StartPage";
import { QuizPage } from "./QuizPage";
import { ResultPage } from "./ResultPage";
import './App.css';

// pages
type Page = "start" | "quiz" | "result";

type AppState = {
    page: Page; // current page
    score: number[]; // current user score
}

// Display UI of curr page
export class App extends Component<{}, AppState> {

    constructor(props: {}) {
        super(props);

        this.state = {
            page: "start",
            score: [0, 0]
        };
    }

    render = (): JSX.Element => {
        if (this.state.page === "start") {
            return <StartPage 
            onStartClick={this.doStartClick}></StartPage>
        } else if (this.state.page === "quiz") {
            return <QuizPage
            onFinishClick={this.doFinishClick}></QuizPage>
        } else if (this.state.page === "result") {
            return <ResultPage
            onRestartClick={this.doRestartClick}
            score={this.state.score}
            ></ResultPage>
        }
        else return <div></div>
    }

    doStartClick = (): void => {
        this.setState({page: "quiz"});
    }

    doFinishClick = (score: number[]): void => {
        this.setState({page: "result", score: score});
    }

    doRestartClick = (): void => {
        this.setState({page: "start"});
    }
}